import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

//Set storage
const isNative = Platform.OS !== "web";

/**
 * Override set function to handle web and native differences
 * @param {Function} _set
 * @returns {Function} set
 */
const Setter = (_set) => {
  const set = (state) => {
    if (isNative) {
      _set(() => state);
    } else {
      _set(state);
    }
  };
  return set;
};

/**
 * Set storage for web and native
 * @param {String} _storage
 * @returns {Object} storage
 */
const Store = (_storage = "local") => {
  let storage;

  //For native
  if (isNative) {
    storage = {
      getItem: async (name) => {
        try {
          return await AsyncStorage.getItem(name);
        } catch (error) {
          console.error("Error getting item from AsyncStorage:", error);
          return null;
        }
      },
      setItem: async (name, value) => {
        try {
          await AsyncStorage.setItem(name, value);
        } catch (error) {
          console.error("Error setting item in AsyncStorage:", error);
        }
      },
      removeItem: async (name) => {
        try {
          await AsyncStorage.removeItem(name);
        } catch (error) {
          console.error("Error removing item from AsyncStorage:", error);
        }
      },
    };

    //For web
  } else {
    switch (_storage) {
      case "local":
        storage = localStorage;
        break;
      case "session":
        storage = sessionStorage;
        break;
      default:
        storage = localStorage;
    }
  }
  return storage;
};

export { Setter, Store };
